import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MdArrowDownward } from 'react-icons/lib/md';
import { withAuth } from '../../actions/';
import { fetchDocumentsFep } from '../../actions/project_actions';

class FepDocumentsTable extends Component {
  // static PropTypes = {
  //   documentsFep: PropTypes.array.isRequired,
  //   fetchDocumentsFep: PropTypes.func.isRequired,
  //   projectId: PropTypes.string.isRequired,
  // }

  constructor(props) {
    super(props);

    this.state = {
      currentPg: 1,
      itemsPerPg: 10,

      document: ''
    }

    this.onDownload = this.onDownload.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.changeNumItemsShown = this.changeNumItemsShown.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.fetchDocumentsFep(this.props.projectId);
  }

  startDownload(result, blobUrl) {
    this.downloadLink.href = blobUrl + result.data.signature;
    this.downloadLink.click();
  }

  onDownload(doc) {
    const { projectId, blobUrl } = doc;
    const url = `projects/${projectId}/documents/download?blobUrl=${encodeURIComponent(blobUrl)}`;
    return (e) => {
      e.preventDefault();
      withAuth(
        { method: 'get', url, responseType: 'blob' },
        (response) => {
          const filename = blobUrl.split('/').pop();
          const windowUrl = window.URL || window.webkitURL;
          const objectUrl = windowUrl.createObjectURL(response.data);
          var a = document.createElement('a');
          a.href = objectUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
        }
      ), () => console.log('file downloaded'), this.notifyError;
    }
  }
  // onDownload(doc) {
  //   const { projectId, blobUrl } = doc;
  //   const sasEndpoint = `projects/${projectId}/documents/sas`;

  //   return (e) => {
  //     e.preventDefault();

  //     withAuth(
  //       { method: 'get', url: sasEndpoint },
  //       (result) => this.startDownload(result, blobUrl),
  //     );
  //   }
  // }

  onChange(e) {
    this.setState({
      document: e.target.value
    });
  }

  handleClick(event) {
    this.setState({
      currentPg: Number(event.target.id)
    });
  }

  changeNumItemsShown(e) {
    if (e.target.value < 5 || e.target.value > this.props.documentsFep.length)
      console.log();
    else {
      this.setState({ itemsPerPg: e.target.value });
    }
  }

  renderRowButtons(doc) {
    return (
      <td>
        <button onClick={this.onDownload(doc)}>
          <span><MdArrowDownward size={22} color='#8492a6' /></span>
        </button>
      </td>
    )
  }

  render() {

    const { documentsFep } = this.props;
    const { currentPg, itemsPerPg } = this.state;

    // Logic for displaying items
    const indexOfLastItem = currentPg * itemsPerPg;
    const indexOfFirstItem = indexOfLastItem - itemsPerPg;
    const currentDocs = documentsFep.slice(indexOfFirstItem, indexOfLastItem);

    // Logic for displaying page numbers
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(this.props.documentsFep.length / itemsPerPg); i++) {
      pageNumbers.push(i);
    }

    return (

      <div className="row-wide fep-docs">
        <div className="col s12">
          <h4 className="bar-bottom">FEP Documents</h4>
        </div>

        {documentsFep.length === 0
          ? <div className="col s12">
            <div>This project has no FEP documents yet.</div>
          </div>
          : <div>

            <div className="row">
              <div className="col s12">
                <div className='controls'>
                  <label>Filter by Document Type</label>
                  <input
                    type="text"
                    value={this.state.document}
                    onChange={this.onChange.bind(this)}
                  />
                </div>
              </div>
            </div>

            <div className="col s12">
              <div className="documents-list">

                <a download ref={link => this.downloadLink = link} target="_blank" className="hidden-link">Download</a>

                <div className="table-wrap">
                  <table>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Version</th>
                        <th>Type</th>
                        <th>Uploaded Date</th>
                        <th>Document Date</th>
                        {<th>Actions</th>}
                      </tr>
                    </thead>

                    {this.state.document !== ''
                      ? <tbody>{documentsFep.filter(doc =>
                        doc.documentTypedesc.toLowerCase().includes(this.state.document.toLowerCase()))
                        .map(filteredDoc =>
                          <tr key={filteredDoc.id}>
                            <td>{filteredDoc.fileName}</td>
                            <td>{filteredDoc.version}</td>
                            <td>{filteredDoc.documentTypedesc}</td>
                            <td>{filteredDoc.uploadedTime.slice(0, 10)}</td>
                            <td>{filteredDoc.documentDate && filteredDoc.documentDate.slice(0, 10)}</td>
                            {this.renderRowButtons(filteredDoc)}
                          </tr>
                        )
                      }</tbody>
                      : <tbody>
                        {currentDocs.map(doc =>
                          <tr key={`doc-${doc.id}`}>
                            <td>{doc.fileName}</td>
                            <td>{doc.version}</td>
                            <td>{doc.documentTypedesc}</td>
                            <td>{doc.uploadedTime.slice(0, 10)}</td>
                            <td>{doc.documentDate && doc.documentDate.slice(0, 10)}</td>
                            {this.renderRowButtons(doc)}
                          </tr>
                        )}
                      </tbody>
                    }

                  </table>
                </div>
              </div>
            </div>

            {this.state.document === '' &&
              <div>
                {pageNumbers.length > 1 &&
                  <div>
                    <div className="col s12">
                      <div className="controls margin-top-1">
                        <label className="label-pagination">Show</label>
                        <input type="number" value={itemsPerPg} onChange={this.changeNumItemsShown}
                          min="5" max={this.props.documentsFep.length - 1} className="input-pagination" />
                        <span className="label-pagination">per page</span>
                      </div>
                    </div>

                    <div className="col s12">
                      <div className="pagination-blue-book">
                        <ul id="page-numbers">
                          {pageNumbers.map(number => {
                            return <li
                              key={number}
                              id={number}
                              onClick={this.handleClick}
                              className={currentPg === number ? 'active' : ''}
                            >
                              {number}
                            </li>
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }

          </div>


        }

      </div>
    );

  }
}

FepDocumentsTable.propTypes = {
  documentsFep: PropTypes.array.isRequired,
  fetchDocumentsFep: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    projectId: ownProps.projectId,
    fetchDocumentsFep: state.projectsStore.fetchDocumentsFep,
    documentsFep: state.projectsStore.documentsFep,
  };
}

export default connect(mapStateToProps, {
  fetchDocumentsFep,
})(FepDocumentsTable);